export const site = {
  name: 'Radiant Reflections',
  category: 'Window Cleaning',
  tagline: 'Crystal Clear Views, Every Time.',
  owner: 'Byron Cano',
  ownerTitle: 'Owner',
  phone: '719-406-0725',
  phoneHref: 'tel:+17194060725',
  email: 'Byronbcano719@gmail.com',
  emailHref: 'mailto:Byronbcano719@gmail.com',
  location: 'Pueblo, Colorado',
  badges: ['Licensed & Insured', 'Reliable', 'Professional'],
}

export type Service = {
  title: string
  description: string
  image: string
  points: string[]
}

export const services: Service[] = [
  {
    title: 'Residential',
    description:
      'Interior and exterior windows, screens, tracks and sills for homes across Pueblo.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b9b0bf46-f4a7-424b-a3cc-785d4023ba07.jpg',
    points: ['Interior & exterior glass', 'Screens & tracks', 'Sills wiped clean'],
  },
  {
    title: 'Commercial',
    description:
      'Storefronts and offices kept presentable, on a schedule that fits your business.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d412c0f8-ee0b-4e3f-8621-56bdfc099e39.jpg',
    points: ['Storefronts & offices', 'Weekly or monthly plans', 'Off-hours available'],
  },
  {
    title: 'Streak-Free Shine',
    description:
      'Purified water and professional squeegee work that leaves nothing behind but glass.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/70a7bfff-3771-48b0-aeec-af6979d4ed2c.jpg',
    points: ['Spot-free finish', 'Hard water treatment', 'Satisfaction guaranteed'],
  },
]

export const steps = [
  {
    title: 'Get in touch',
    description: 'Call or email with your address and how many windows you have.',
  },
  {
    title: 'Free quote',
    description: 'A clear, flat price up front — no surprises once the work starts.',
  },
  {
    title: 'Clear views',
    description: 'We clean, tidy up, and walk the property with you before we leave.',
  },
]
